import { CommonModule } from '@angular/common';
import { Component, input, type InputSignal } from '@angular/core';

@Component({
  selector: 'app-simple-horizontal-bar',
  imports: [
    CommonModule
  ],
  templateUrl: './simple-horizontal-bar.html',
  styleUrl: './simple-horizontal-bar.css'
})
export class SimpleHorizontalBar {
  public data: InputSignal<any> = input<any>({
    labels: [],
    dataset: {}
  });

  public getPertentItem(index: number): number {
    if (!this.data()?.dataset?.data) return 0;
    const total = this.data().dataset.data.reduce((acc: number, item: number) => acc + item, 0);
    if (total === 0) return 0;
    return ((this.data().dataset.data[index] / total) * 100);
  }

  public getColor(index: number): string {
    return this.data()?.dataset?.backgroundColor?.[index] || '';
  }
}
